import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VInput } from '@/package';
import { useUnleash } from '@/package';

import type { TaskCreateFormType } from './type';

export const TaskDistsance = ({ readonly }: { readonly: boolean }) => {
  const { t } = useTranslation();
  const {
    register,
    getValues,
    formState: { touchedFields },
  } = useFormContext<TaskCreateFormType>();
  const { getVariantPayloadValue } = useUnleash();
  const distanceConfig = getVariantPayloadValue(
    'vuex.sapporo.defaultDistanceValue',
  ) as {
    default: number;
    max: number;
    min: number;
  };

  const validateDistance = (value?: string | number) => {
    const currentValue = value ?? getValues('distance');
    if (!currentValue) return false;
    const numValue = Number(currentValue);
    return (
      !isNaN(numValue) &&
      numValue >= distanceConfig.min &&
      numValue <= distanceConfig.max
    );
  };

  return (
    <VInput
      {...register('distance', {
        validate: validateDistance,
      })}
      className="w-full"
      label={t('preAnnotation.distance.rejuvenate')}
      type="number"
      max={distanceConfig.max}
      min={distanceConfig.min}
      defaultValue={distanceConfig.default}
      required
      readOnly={readonly}
      valid={!touchedFields.distance || validateDistance()}
      renderRightSide={() => 'M'}
      // onChange={clampValueOnChange(register('distance'))}
    />
  );
};
